const Excel = ({ size }: { size: number }) => (
  <svg
    width={size}
    height={size}
    viewBox={`0 0 ${size} ${size}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 16.0001L14.242 13.6321L9 16.0001V26.8341C9 26.9873 9.03019 27.139 9.08885 27.2805C9.14751 27.4221 9.23349 27.5506 9.34187 27.6589C9.45025 27.7672 9.5789 27.8531 9.72048 27.9116C9.86206 27.9701 10.0138 28.0002 10.167 28.0001H28.834C29.1432 28.0001 29.4398 27.8772 29.6585 27.6586C29.8772 27.4399 30 27.1433 30 26.8341V22.0001L20 16.0001Z"
      fill="#185C37"
    />
    <path
      d="M20 4H10.167C9.85749 4 9.56066 4.12295 9.34181 4.34181C9.12295 4.56066 9 4.85749 9 5.167V10L20 16L25 18.368L30 16V10L20 4Z"
      fill="#21A366"
    />
    <path
      d="M28.834 4H20V10H30V5.167C30.0001 5.01379 29.9701 4.86207 29.9115 4.72048C29.853 4.5789 29.7671 4.45025 29.6588 4.34187C29.5506 4.23349 29.422 4.14751 29.2804 4.08885C29.1389 4.03019 28.9872 4 28.834 4Z"
      fill="#33C481"
    />
    <path d="M9 10H20V16H9V10ZM20 16H30V22H20V16Z" fill="#107C41" />
    <path
      opacity="0.5"
      d="M17 11V22.83C16.9979 23.1397 16.874 23.436 16.655 23.655C16.436 23.874 16.1397 23.9979 15.83 24H9V10H16C16.2652 10 16.5196 10.1054 16.7071 10.2929C16.8946 10.4804 17 10.7348 17 11Z"
      fill="#000000"
    />
    <path
      d="M14.833 9H3.16798C2.52346 9 2.00098 9.52248 2.00098 10.167V21.832C2.00098 22.4765 2.52346 22.999 3.16798 22.999H14.833C15.4775 22.999 16 22.4765 16 21.832V10.167C16 9.52248 15.4775 9 14.833 9Z"
      fill="#107C41"
    />
    <path
      d="M5.0918 20.375L7.9228 15.988L5.3298 11.625H7.4168L8.8318 14.414C8.9618 14.6807 9.05146 14.8777 9.1008 15.005H9.1188C9.2128 14.794 9.3098 14.589 9.4118 14.389L10.9248 11.625H12.8408L10.1808 15.963L12.9078 20.375H10.8698L9.2348 17.312C9.15616 17.1819 9.08923 17.045 9.0348 16.903H9.0148C8.96776 17.0433 8.90432 17.1776 8.8258 17.303L7.1418 20.375H5.0918Z"
      fill="#FFFFFF"
    />
  </svg>
);

export default Excel;
